var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"home-title"},[_c('div',{staticClass:"cover-border top",class:{ animated: _vm.isActive }}),_c('div',{class:{ animated: _vm.isActive }},[_c('img',{staticClass:"logo",class:_vm.size,attrs:{"src":"img/logo/logo.svg"}})])]),_c('div',{staticClass:"cover-border bottom",class:{ animated: _vm.isActive }})])
}
var staticRenderFns = []

export { render, staticRenderFns }